declare global {
	interface Window {
		_nli: unknown[]
	}
}

export default class Nonli {
	private url: string | null
	private brand: string | null

	constructor() {
		const el = document.querySelector<HTMLElement>('#nonli-loader')
		this.url = el?.dataset.url ?? null
		this.brand = el?.dataset.brand ?? null
	}

	init() {
		if (!this.url) return

		window._nli = window._nli || []
		if (this.brand) {
			window._nli.push(['brand', this.brand])
		}

		const script = document.createElement('script')
		script.defer = true
		script.src = this.url
		document.head.appendChild(script)
	}
}
